import { Component, inject, OnInit } from '@angular/core';
import { MenuService } from './services/menu.service';
import { MenuItem } from 'primeng/api';
import { GlobalLoadingService } from 'app/core/services/loading.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
  host: {
    class: 'flex w-full h-screen relative',
  },
})
export class AdminLayoutComponent implements OnInit {
  private globalLoadingService = inject(GlobalLoadingService);
  private menuService = inject(MenuService);
  menuItems$!: Observable<MenuItem[]>;
  loading$!: Observable<boolean>;

  ngOnInit() {
    this.menuItems$ = this.menuService.menuItems;
    this.loading$ = this.globalLoadingService.loading$;
  }
}
